export default {
  "conflicts": "_conflicts_1ssux_1",
  "toolbarConnector": "_toolbarConnector_1ssux_6",
  "conflictBase": "_conflictBase_1ssux_31",
  "conflictHead": "_conflictHead_1ssux_34",
  "verticalConnector": "_verticalConnector_1ssux_39",
  "conflictBadge": "_conflictBadge_1ssux_59",
  "highlightContainer": "_highlightContainer_1ssux_66",
  "highlight": "_highlight_1ssux_66",
  "main": "_main_1ssux_79",
  "current": "_current_1ssux_83"
};import "ni:sha-256;xCgJ2mpDRXCTqBRWtV9GjSiOgcBvipXLVt8dguQK3UQ";